export default "__VITE_ASSET__DP7gp45f__"